'use strict';

require('./vendor');

var Isotope = require('isotope-layout/dist/isotope.pkgd.js');
var imagesLoaded = require('imagesloaded');

// provide jQuery argument
imagesLoaded.makeJQueryPlugin($);


$(document).ready(function() {

  // cookieHandler();

  $('.image-popup').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    closeBtnInside: false,
  	closeOnBgClick: true,
    mainClass: 'mfp-selector mfp-zoom', // class to remove default margin from left and right side
    image: {
      verticalFit: true
    },
    zoom: {
      enabled: true,
      duration: 300 // don't foget to change the duration also in CSS
    },
  });

  $('a#language-icon').click(function(e) {
    e.preventDefault();
  });

  // Text border
  $('.text-border').each(function() {
    var words = $(this).text().split(/\s+/);
    var total = words.length;
    var index = 0;
    $(this).empty();
    for (index = 0; index < total; index++) {
      $(this).append($("<span class='text-border-inner'>" + words[index] + "</span>"));
    }
    $(this).find('span.text-border-inner').unwrap();
  });

  // Header animation

  var counter = 1;
  setInterval(function() {
    if (counter == $('.laptop .screen .image').length) {
      counter = 0;
    }
    counter++;
    $('.animation-wrapper').removeClass(function(index, css) {
      return (css.match(/\bslide\S+/g) || []).join(' ');
    });
    $('.animation-wrapper').addClass('slide' + counter).addClass('slideout');
    setTimeout(function() {
      $('.animation-wrapper').removeClass('slideout');
    }, 1000);
  }, 2000);

  // Text animation
  var counter2 = 1;

  setInterval(function() {
    if (counter2 == $('.text-animation div').length) {
      counter2 = 0;
    }
    counter2++;
    $('.text-animation div.active').removeClass('active').addClass('slideout');
    $('.text-animation div:nth-child(' + counter2 + ')').addClass('active');
    $('.text-animation').width($('.text-animation div:nth-child(' + counter2 + ')').width());
    setTimeout(function() {
      $('.text-animation div').removeClass('slideout');
    }, 1000);
  }, 2000);

  // Laptop animation
  /*
  setInterval(function() {
  	if ($('#device').hasClass('laptop')) {
  		changeDeviceClass('tablet');
  		slideImage('img/whitepaper.jpg');
  	} else if ($('#device').hasClass('tablet')) {
  		changeDeviceClass('mobile');
  		slideImage('img/productcatalog.jpg');
  	} else {
  		changeDeviceClass('laptop');
  		slideImage('img/magazine.jpg');
  	}
  }, 3000);
  */
  function changeDeviceClass(className) {
    $('#device').removeClass();
    $('#device').addClass(className);
  }

  function slideImage(imagePath) {
    $('.image:nth-child(1)').removeClass('active').addClass('slideout');
    $('.image:nth-child(2)').css('background-image', 'url(' + imagePath + ')').addClass('active');
    setTimeout(function() {
      $('.image:nth-child(1)').insertAfter('.image:nth-child(2)').removeClass('slideout');
    }, 1000);
  }

  function textBorder() {
    $('.text-border-inner').each(function(_, e) {
      if ($(e).offset().top < $(window).scrollTop() + $(window).height() / 1.25) {
        $(e).addClass('show');
      }
    });
  }

  function showImage() {
    $('.animate').each(function(_, e) {
      if ($(e).offset().top < $(window).scrollTop() + $(window).height() / 1.3) {
        $(e).addClass('show');
      }
    });
  }

  function showContainer() {
    $('.img-container').each(function(_, e) {
      if ($(e).offset().top < $(window).scrollTop() + $(window).height() / 1.5) {
        $(e).addClass('show');
      }
    });
  }

  function scaleContainer(container) {
    var value = $(window).width() / 1200;
    $('.images > img').css({
      'transform': 'scale(' + value + ')'
    });
  }

  function fixedNav() {
    if ($(window).scrollTop() > 1) {
      $('body').addClass('sticky-nav');
    } else {
      $('body').removeClass('sticky-nav');
    }

    if ($('.table-wrapper').length) {
      if ($('.table-wrapper').position().top < $(window).scrollTop() + 75 && $(window).scrollTop() < ($('.table-wrapper').position().top + $('.table-wrapper').height() - 100)) {
        $('.table-wrapper').addClass('sticky-nav');
      } else {
        $('.table-wrapper').removeClass('sticky-nav');
      }
    }
  }

  function closeNav() {
    if ($(window).width() > 1024) {
      $('body').removeClass('menu-open');
    }
  }

  function animateSectionSVG() {
    $('.section .svg').each(function(_, e) {
      if ($(e).offset().top < $(window).scrollTop() + $(window).height() / 1.3 && !($(e).hasClass('show'))) {
        $(e).addClass('show')
      }
    })
  }

  // Menu
  $('.menu-button').click(function(e) {
    e.preventDefault();
    $('body').toggleClass('menu-open');
  });

  // Scroll down
  $('.scroll-down').click(function(e) {
    e.preventDefault();
    $("html, body").animate({
      scrollTop: ($('header').height() + 100)
    });
  });

  // Scroll to anchor
  $('.scroll-to-anchor').click(function(e) {
    e.preventDefault();
    var targetID = $(this).attr('href').replace('#', '');
    $("html, body").animate({
      scrollTop: $('#' + targetID).offset().top - 120
    });
  });

  // Faq
  $('.faq-question h5, .faq-icon').click(function(e) {
    e.preventDefault();
    $('.faq-extended').stop();
    parent = $(this).closest('.faq-item');
    if (parent.hasClass('active')) {
      parent.find('.faq-extended').slideUp(100);
      parent.removeClass('active').addClass('slide-up');
      setTimeout(function(){
        parent.removeClass('slide-up');
      },300);
    } else {
      $('.faq-extended').slideUp(100);
      $('.faq-item').removeClass('active');
      parent.find('.faq-extended').slideDown(100);
      parent.addClass('active');
    }
  });
  //initial load
  $('.faq-extended').slideUp(100);
  $('.faq-item').removeClass('active');

  //submenu click animation
  $('.submenu a').click(function(e) {
    var thisElement = $(this);
    var thisParent = $(this).parent('li');
    e.preventDefault()
    $('html, body').stop();
    $('html, body').animate({
      scrollTop: $(`#${this.href.split('#')[1]}`).offset().top - 99
    }, 1000, function() {
      $('.submenu li').removeClass('active');
      $(thisParent).addClass('active');
    });
  });

  function toggleSubmenu() {
    var scrollTop = $(window).scrollTop();
    $('.submenu a').each(function(i, a) {
      if (scrollTop > $(`#${a.href.split('#')[1]}`).offset().top - 100) {
        var parent = $(a).parent('li');
        $('.submenu li').removeClass('active');
        $(parent).addClass('active');
      } else {
        $(a).removeClass('active');
      }
    });
  }

  function switchPrices(periodChanged) {
    var currency = $('input[name=currency]:checked').val();
    var period = $('#period').data('period');

    $('.price').each(function(i, a) {
      var priceName = currency + '-' + period;
      var price = $(a).children('.amount').data(priceName);
      $(a).children('.amount').animateNumber({
        number: price
      });
    });

    $('.table-amount').each(function(i, a) {
      var price = $(this).data(currency);
      $(this).animateNumber({
        number: price
      });
    });

    if (periodChanged) {
      $('.periodtext').hide();
      $('.periodtext.' + period).fadeIn();
    }

    switch (currency) {
      case 'eur':
        $('.vcurrency').html('&euro;');
        break;
      case 'usd':
        $('.vcurrency').html('&dollar;');
        break;
      case 'gbp':
        $('.vcurrency').html('&pound;');
        break;
    }
  }

  // Filter period
  $('.period label, .switch').click(function() {
    var slider = $('.slider');
    var switchBtn = $('#period');

    slider.toggleClass('right');
    if (slider.hasClass('right')) {
      switchBtn.data('period', 'year');
      switchPrices(true);
    } else {
      switchBtn.data('period', 'month');
      switchPrices(true);
    }
  });

  $('input[name=currency]').change(function() {
    switchPrices(false);
  });

  $('.masonry').imagesLoaded(function() {
    if ($('.masonry').length) {
      if ($('.masonry').hasClass('random')) {
        var sortBy = 'random';
      } else {
        var sortBy = 'original-order';
      }

      var options = {
        itemSelector: '.item',
        layoutMode: 'masonry',
        percentPosition: true,
        sortBy: sortBy
      };

      var elem = document.querySelector('.masonry');

      //hack for triggering too early
      setTimeout(function() {
        var iso = new Isotope(elem, options);
        // Show grid when sorting is done (also css delay).
        $('.masonry').addClass('show');
      }, 250);
    }
  });

  // $(function () {
  //   var parent = $(".randomize-grid");
  //     var divs = parent.children();
  //     while (divs.length) {
  //         parent.append(divs.splice(Math.floor(Math.random() * divs.length), 1)[0]);
  //     }
  // });

  //select tag got to url
  $('#tagselect').on('change', function() {
    var url = $(this).val(); // get selected value
    if (url) { // require a URL
      window.location = url; // redirect
    }
    return false;
  });

  // reveal video
  var src;
  $('div[data-toggle="modal-video"]').click(function() {
    src = $(this).attr('data-video');
    $('.reveal iframe').attr('src', 'https://www.youtube.com/embed/' + src + '?autoplay=1&modestbranding=0&rel=0&showinfo=0');
  });

  $('.reveal .close-button').click(function() {
    $('.reveal iframe').attr('src', 'https://www.youtube.com/embed/' + src + '');
  });

  // Scroll
  $(window).scroll(function() {
    textBorder();
    showImage();
    showContainer();
    animateSectionSVG();
    fixedNav();
    toggleSubmenu();
  });

  // Scroll
  $(window).resize(function() {
    closeNav();
  });

  // Bxslider
  if ($('.reviews').length) {
    var slider = $('.reviews').bxSlider({
      touchEnabled: false,
      auto: true,
      pause: 5000
    });
  }

  // Init
  setTimeout(function() {
    textBorder();
    showImage();
    showContainer();
    animateSectionSVG();
    $('.text-animation').width($('.text-animation div.active').width());
    $(window).trigger('resize');
    if (slider) {
      slider.reloadSlider();
    }
  }, 500);

  fixedNav();
  closeNav();

  $(document).foundation();

});

function cookieHandler() {
  setTimeout(function() {
    $('#cookiebar').addClass('show');
  }, 2000);

  $('.accept').on('click', function() {
    $('#cookiebar').addClass('accepted');
    $('#cookiebar').removeClass('show');
  });
}

if (module.hot) {
  module.hot.accept()
}
